

export class keyboardHandler3 {

    isShift() {
        return this.command == "Shift";
    }


    isEnter() {
        return this.command == "Enter";
    }

    isBackspace() {
        return this.command == "Backspace";
    }

    isDelete() {
        return this.command == "Delete"
    }

    isEqual() {
        return this.command == "=";
    }

    isDash() {
        return this.command == "-";
    }

    isZoomPlus() {
        return this.command == "ctrl+=" || this.command == "cmd+=";
    }

    isZoomMinus() {
        return this.command == "ctrl+-" || this.command == "cmd+-";
    }

    isArrow() {
        return this.command == "ArrowLeft" || this.command == "ArrowRight" || this.command == "ArrowUp" ||  this.command == "ArrowDown";
    }

    isArrowShift() {
        return this.command == "ArrowLeft+shift" || this.command == "ArrowRight+shift" || this.command == "ArrowUp+shift" ||  this.command == "ArrowDown+shift";
    }

    isLeftArrow() {
        return this.command == "ArrowLeft" || this.command == "ArrowLeft+shift";
    }

    isRightArrow() {
        return this.command == "ArrowRight" || this.command == "ArrowRight+shift";
    }

    isUpArrow() {
        return this.command == "ArrowUp" || this.command == "ArrowUp+shift";
    }

    isDownArrow() {
        return this.command == "ArrowDown" || this.command == "ArrowDown+shift";
    }

    isSelectAll() {
        return this.command == "ctrl+a" || this.command == "cmd+a";
    }

    isGroupCommand() {
        return this.command == "ctrl+g" || this.command == "cmd+g";
    }

    isUnGroupCommand() {
        return this.command == "ctrl+shift+g" || this.command == "cmd+shift+g";
    }

    isCutCommand() {
        return this.command === 'ctrl+x' || this.command === 'cmd+x';
    }

    isCopyCommand() {
        return this.command == "ctrl+c" || this.command == "cmd+c";
    }

    isPasteCommand() {
        return this.command == "ctrl+v" || this.command == "cmd+v";
    }

    isDuplicateCommand() {
        return this.command == "ctrl+d" || this.command == "cmd+d";
    }

    isToFrontCommand() {
        return this.command == "ctrl+]" || this.command == "cmd+]";
    }

    isToBackCommand() {
        return this.command == "ctrl+[" || this.command == "cmd+[";
    }

    isUndoCommand() {
        return this.command == "ctrl+z" || this.command == "cmd+z";
    }

    isRedoCommand() {
        return this.command == "ctrl+shift+z" || this.command == "cmd+shift+z";
    }

    isPenToolCommand() {
        return this.code == "KeyP";
    }

    isCardToolCommand() {
        return this.code == "KeyD";
    }

    isShapeToolCommand() {
        return this.code == "KeyS";
    }

    isShapeToolCommandWithCircleMode() {
        return this.code == "KeyO";
    }

    isShapeToolCommandWithRectMode() {
        return this.code == "KeyR";
    }

    isStickerToolCommand() {
        return this.code == 'KeyN';
    }

    isTextToolCommand() {
        return this.code == 'KeyT';
    }

    isCommentToolCommand() {
        return this.code == 'KeyC';
    }

    isMouseOrHandCommand() {
        return this.code == 'KeyH' || this.code == 'KeyV';
    }

    isArrowToolCommand() {
        return this.code == "KeyL";
    }

    isEraserToolCommand() {
        return this.code == "KeyE";
    }

    isEscCommand() {
        return this.command == "escape";
    }

    isCommandEnter() {
        return this.command == "cmd+enter" || this.command == "ctrl+enter";
    }

    isCommandShiftEnter() {
        return this.command == "cmd+shift+enter" || this.command == "ctrl+shift+enter";
    }

    isSearchShortcut() {
        return this.command == "cmd+f" || this.command == "ctrl+f";
    }

    isBoldShortcut() {
        return this.command == "cmd+b" || this.command == "ctrl+b";
    }

    isShiftHome() {
        return this.command === "shift+home" || this.command === "shift+cmd+ArrowLeft";
    }

    isShiftEnd() {
        return this.command === "shift+end" || this.command === "shift+cmd+ArrowRight";
    }

    isAlt() {
        return this.command === "alt";
    }

    isZoomToSelected() {
        return this.command === 'alt+2';
    }

    isZoomToFit() {
        return this.command === 'alt+1';
    }

    isZoomTo100() {
        return this.command === 'ctrl+0' || this.command === 'cmd+0';
    }

    code = '';
    command = '';
    isSymbol = false;
}
